import { render, staticRenderFns } from "./informationBox2.vue?vue&type=template&id=53e4e2c2&scoped=true"
import script from "./informationBox2.vue?vue&type=script&lang=js"
export * from "./informationBox2.vue?vue&type=script&lang=js"
import style0 from "./informationBox2.vue?vue&type=style&index=0&id=53e4e2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4e2c2",
  null
  
)

export default component.exports